import React from 'react';
import { FormState, Form as FormStateForm } from 'react-formstate';
import classNames from 'classnames';
import WiredInput from '../components/WiredInput';
import { focusOnFirstInvalid, populateFormErrors } from '../../utils/validation';
import ValidationMessage from '../components/ValidationMessage';
import WiredTextArea from '../components/WiredTextArea';
import Label from '../components/Label';

export default class Form extends React.Component {
  constructor(props) {
    super(props);
    this.formState = FormState.create(this);
    this.state = this.formState.injectModel(props.fields);
  }

  componentDidMount() {
    const { fields: { content } = {} } = this.props;

    this.redactor = Redactor('#redactor', {
      minHeight: '15rem',
      focusEnd: true
    });

    if (content) {
      this.redactor.source.setCode(content);
    }
  }

  onNotificationLabelClick = ({ target: { tagName } }) => {
    // event is fired twice, for checkbox and for label. Ignore one of them.
    if (tagName === 'INPUT') return;

    const context = this.formState.createUnitOfWork();
    const fieldState = context.getFieldState('notification');
    fieldState.setValue(+fieldState.getValue('notification') ^ 1).validate();
    context.updateFormState();
  };

  onSubmit = (e) => {
    e.preventDefault();
    const context = this.formState.createUnitOfWork();

    if (this.redactor) {
      const content = this.redactor.source.getCode();
      context.set('content', content).validate();
      context.updateFormState();
    }

    const model = context.createModel();
    if (model) {
      const { onSubmit } = this.props;
      onSubmit(e, model);
    } else {
      focusOnFirstInvalid(this.formState, this);
    }
  };

  render() {
    const { onCancel, fields } = this.props;

    const errors = populateFormErrors(this.formState);

    const articleId = typeof fields === 'undefined' ? 0 : fields.articleId;

    return (
      <FormStateForm formState={this.formState} onSubmit={this.onSubmit} className="c-popup campaign-edit">
        <div className="c-inactive-bg__stop">
          <div className="c-popup__head">
            <div className="c-popup__close">
              <a href="#" onClick={onCancel}>
                <i className="icon-close" />
              </a>
            </div>
          </div>
          <fieldset>
            <div className="c-popup__body">
              <header>
                <h1 className="campaign-edit__header">{ articleId > 0 ? <span>Upraviť komentár</span> : <span>Pridať komentár</span> }</h1>
              </header>
              <div>
                <div className="l-row l-no-padding">
                  <div className="l-5-5 l-no-l-padding">
                    <label className="c-input__wrapper">
                      <span className="c-input__label">Text komentára</span>
                      <span>
                        <WiredTextArea
                          name="content"
                          className="c-input"
                          style={{ display: 'none' }}
                          onChange={() => {}}
                          validator={v => v.required().msg('Clanok by mal mat popis')}
                        />
                        <textarea id="redactor" />
                      </span>

                      <ValidationMessage msg={errors.content} />
                    </label>
                  </div>
                </div>

                { articleId > 0 ?
                    <div></div>
                  :
                    <div className="l-row l-no-padding">
                      <div className="l-5-5 l-no-l-padding">
                        <Label className="c-checkbox" onClick={this.onNotificationLabelClick}>
                          <WiredInput
                            type="checkbox"
                            name="notification"
                            defaultValue={0}
                            className="c-checkbox__input"
                          />
                          <i className="icon-radio c-checkbox__icon" />
                          <span className="c-checkbox__text">
                            Poslať notifikáciu o tomto komentári aktuálnym darcom
                          </span>
                        </Label>
                      </div>
                    </div>
                }

                <div className="expander" />
                <div className="expander--1-2" />

                <div className="campaign-edit__bottom-buttons">
                  <button type="submit" className="campaign-edit__button campaign-edit__button--submit c-button">
                    <span className="c-button__content">Uložiť zmeny</span>
                  </button>

                  <button
                    type="button"
                    className="campaign-edit__button campaign-edit__button--cancel c-button"
                    onClick={onCancel}
                  >
                    <span className="c-button__content">Zrušiť</span>
                  </button>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </FormStateForm>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/articleEditor/Form.js